import { render } from "./Ce006.vue?vue&type=template&id=08e1f0e0"
import script from "./Ce006.vue?vue&type=script&lang=js"
export * from "./Ce006.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__